import intersection from 'lodash/intersection';

import { CLASS_TYPES } from '@classCreation/data/classTypes';
import { INSTRUCTOR_CATEGORIES } from '@classCreation/data/instructorCategories';
import { RESCHEDULE_CLASSES_FILTERS } from '@classCreation/data/rescheduleClassesFilters';
import getSbatGroupInstructorsByCategory from '@classCreation/utils/getSbatGroupInstructorsByCategory';
import hasContestLesson from './hasContestLesson';
import { TypeUtils } from '@vectord/utils';
import { LECTURE_TYPES } from '../data/lectureTypes';
import hasLiveLecture from './hasLiveLecture';

export default function applyFiltersOnRescheduleClasses({
  sbatGroup,
  filters,
}) {
  const results = [];

  if (filters[RESCHEDULE_CLASSES_FILTERS.academyModules]) {
    const filterAcademyModuleIds = filters[
      RESCHEDULE_CLASSES_FILTERS.academyModules
    ].map(({ value }) => value);
    results.push(
      filterAcademyModuleIds.includes(sbatGroup.academy_topic.academy_module.id)
    );
  }

  if (filters[RESCHEDULE_CLASSES_FILTERS.classType]) {
    const filteredClassType =
      filters[RESCHEDULE_CLASSES_FILTERS.classType].value;

    const isContest = hasContestLesson(sbatGroup.academy_topic.lessons);
    const isLiveLecture = hasLiveLecture(sbatGroup.academy_topic.lessons);

    if (filteredClassType === CLASS_TYPES.contest) {
      results.push(isContest);
    } else if (filteredClassType === CLASS_TYPES.classWithoutLiveLecture) {
      results.push(!isLiveLecture && !isContest);
    } else {
      results.push(!isContest && isLiveLecture);
    }
  }

  if (filters[RESCHEDULE_CLASSES_FILTERS.lectureType]) {
    const filteredLectureType =
      filters[RESCHEDULE_CLASSES_FILTERS.lectureType].value;

    const isRegular = TypeUtils.isNullOrUndefined(
      sbatGroup.academy_topic.lecture_bucket
    );

    results.push(
      filteredLectureType === LECTURE_TYPES.regular ? isRegular : !isRegular
    );
  }

  if (filters[RESCHEDULE_CLASSES_FILTERS.primaryInstructors]) {
    const filterInstructorsIds = filters[
      RESCHEDULE_CLASSES_FILTERS.primaryInstructors
    ].map(({ value }) => value);
    const sbatGroupInstructorsIds = getSbatGroupInstructorsByCategory(
      sbatGroup,
      INSTRUCTOR_CATEGORIES.primary
    ).map(({ instructor_id }) => instructor_id);

    results.push(
      intersection(filterInstructorsIds, sbatGroupInstructorsIds).length > 0
    );
  }

  if (filters[RESCHEDULE_CLASSES_FILTERS.secondaryInstructors]) {
    const filterInstructorsIds = filters[
      RESCHEDULE_CLASSES_FILTERS.secondaryInstructors
    ].map(({ value }) => value);
    const sbatGroupInstructorsIds = getSbatGroupInstructorsByCategory(
      sbatGroup,
      INSTRUCTOR_CATEGORIES.secondary
    ).map(({ instructor_id }) => instructor_id);

    results.push(
      intersection(filterInstructorsIds, sbatGroupInstructorsIds).length > 0
    );
  }

  if (filters[RESCHEDULE_CLASSES_FILTERS.fromDate]) {
    results.push(
      new Date(sbatGroup.date_of_topic) >=
        new Date(filters[RESCHEDULE_CLASSES_FILTERS.fromDate])
    );
  }

  if (filters[RESCHEDULE_CLASSES_FILTERS.toDate]) {
    results.push(
      new Date(sbatGroup.date_of_topic) <=
        new Date(filters[RESCHEDULE_CLASSES_FILTERS.toDate])
    );
  }
  return results.every((result) => result);
}
